/*
 * Copyright (c) 2021 LucidResolutions LLC. All rights reserved.
 */

import APIBaseService from "./api.base.service";
import AuthService from "./auth.service";

const url = "/v1/user"
class UserService extends APIBaseService{
    authSVC: AuthService;
    ctx: any;
    constructor(authSVC?: AuthService, ctx?: any) {
        super();
        this.usePathPrefix(url)
        if(!authSVC){
            this.authSVC = new AuthService()
        } else {
            this.authSVC = authSVC;
        }

        this.ctx = ctx;
    }

    async login(email: string, password: string, twoFactor?: string){
        this.authSVC.removeToken()
        let result = await this.post(`login`, {
            email: email,
            password: password,
            two_factor_code: twoFactor
        }, {
            //encrypt: true,
            //decrypt: true,
        })

        this.raiseIfBadStatus(result, 200)

        return result.data
    }

    async hasTwoFactor(email: string){
        let result = await this.post('has-two-factor', {
            email: email
        }, {
            // encrypt: true,
            // decrypt: true
        })

        this.raiseIfBadStatus(result, 200)

        return result.data
    }

    async enableTwoFactor(secret: string, code: string){
        let result = await this.post('enable-two-factor', {
            secret: secret,
            code: code,
        }, {
            //encrypt: true,
            authorized: true
        })

        this.raiseIfBadStatus(result, 204)
    }

    async disableTwoFactor( code: string){
        let result = await this.delete('disable-two-factor',  {
            //encrypt: true,
            authorized: true,
            data: {
                code: code,
            }
        })

        this.raiseIfBadStatus(result, 204)
    }

    async generateTwoFactor(){
        let result = await this.get('generate-two-factor',  {
            //decrypt: true,
            authorized: true
        })

        this.raiseIfBadStatus(result, 200)

        return result.data
    }

    async info(){
        let result = await this.get('info',  {
            //decrypt: true,
            authorized: true
        })

        this.raiseIfBadStatus(result, 200)

        return result.data
    }

    async register(email: string, password: string, license: string){
        this.authSVC.removeToken()
        let result = await this.post(`register`, {
            email: email,
            password: password,
            reference_id: license,
        }, {
            maxRetries: 1,
            //encrypt: true
        })

        this.raiseIfBadStatus(result, 204)
        return result.data
    }

    async forgot(email: string){
        this.authSVC.removeToken()
        let result = await this.post(`forgot`, {
            email: email,
        }, {
            //encrypt: true
        })

        this.raiseIfBadStatus(result, 204)
    }

    async reset(newPassword: string, token: string){
        this.authSVC.removeToken()
        let result = await this.post(`reset`, {
            password: newPassword,
            token: token,
        }, {
            //encrypt: true
        })

        this.raiseIfBadStatus(result, 204)
    }

    async verify(email: string){
        let result = await this.post(`email-verify`, {
            email: email,
        }, {
            //encrypt: true
        })

        this.raiseIfBadStatus(result, 204)
    }

}

export default UserService;
